import { render, staticRenderFns } from "./urlLink.vue?vue&type=template&id=0267b2d6"
import script from "./urlLink.vue?vue&type=script&lang=js"
export * from "./urlLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports